import rightarrow from "../../assets/images/right-arrow.png";
import "./Footer.scss";
const Navigate = (props) => {
  return (
    <div className="navigate mobile">
      <div className="container">
        <a href={props.pagelink}>
          <div className="custom-row">
            <div className="left">
              <div className="next">Next</div>
              <div>{props.page}</div>
            </div>
            <img src={rightarrow} alt="next" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default Navigate;
